import { parseMoney, formatCents } from './money';

const low = confidence => new Set(Object.entries(confidence || {}).filter(([, c]) => c < 0.8).map(([k]) => k));
const centsText = c => (c == null ? '' : (c / 100).toFixed(2));

export function draftFromInvoiceReading(r, vendors) {
  const match = vendors.find(v => v.name.toLowerCase() === String(r.vendor_name || '').trim().toLowerCase());
  return {
    vendorId: match?.id,
    invoiceNumber: r.invoice_number || '', invoiceDate: r.invoice_date || '',
    totalText: centsText(r.total_cents), lowConfidence: low(r.confidence),
  };
}

export function checksFromReading(list, accounts) {
  return list.map(c => ({
    checkNumber: String(c.check_number || '').replace(/\D/g, ''), dueDate: c.date || '', amountText: centsText(c.amount_cents),
    bankAccountId: accounts.find(a => a.account_last4 && a.account_last4 === c.account_last4)?.id ?? null,
    low: low(c.confidence),
  }));
}

export const checkRowComplete = c => /^\d+$/.test(c.checkNumber) && /^\d{4}-\d{2}-\d{2}$/.test(c.dueDate) && parseMoney(c.amountText) != null && Boolean(c.bankAccountId);

export const checksComplete = list => list.length > 0 && list.every(checkRowComplete);

export function reviewSummary(draft, checks, accounts, vendors) {
  const amounts = checks.map(c => parseMoney(c.amountText) || 0);
  const totalCents = parseMoney(draft.totalText) || 0;
  const sum = amounts.reduce((s, a) => s + a, 0);
  const dates = checks.map(c => c.dueDate).sort();
  return {
    allSame: amounts.every(a => a === amounts[0]), count: checks.length, amountCents: amounts[0] || 0,
    totalCents, diffCents: totalCents - sum, firstDate: dates[0],
    accountName: accounts.find(a => a.id === checks[0]?.bankAccountId)?.nickname || '',
    vendorName: vendors.find(v => v.id === draft.vendorId)?.name || '',
    sumText: formatCents(sum),
  };
}
